import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateScorecardMutationVariables = Types.Exact<{
  input: Types.UpdateScorecardInput;
}>;


export type UpdateScorecardMutation = { updateScorecard: { success?: boolean | null, errorCode?: string | null, scorecard?: { id: string } | null } };


export const UpdateScorecardDocument = /*#__PURE__*/ gql`
    mutation updateScorecard($input: UpdateScorecardInput!) {
  updateScorecard(data: $input) {
    success
    errorCode
    scorecard {
      id
    }
  }
}
    `;

export function useUpdateScorecardMutation() {
  return Urql.useMutation<UpdateScorecardMutation, UpdateScorecardMutationVariables>(UpdateScorecardDocument);
};